import { TableComposable, Thead, Tbody, Tr, Th } from '@patternfly/react-table'
import * as React from 'react'
import styled from 'styled-components'

import type { IDomainEvent } from '@app/domain/domain-events/domain-events.interface'

import { DomainEventHeader } from './domain-event-header'
import { DomainEventRow } from './domain-event-row'

interface Props {
  className?: string
  domainEvents: IDomainEvent[]
  expandedRows: Record<string, boolean>
  handleExpanded: (domainEventId: string) => void
}

const DomainEventsTable = function ({
  className,
  domainEvents,
  expandedRows,
  handleExpanded,
}: Props) {
  return (
    <TableComposable
      className={className}
      aria-label="Expandable Table"
      variant={'compact'}
    >
      <Thead>
        <Tr>
          <Th />
          <Th>Type</Th>
          <Th>Source</Th>
          <Th>Subject</Th>
          <Th>Time</Th>
        </Tr>
      </Thead>
      {domainEvents.map((domainEvent, index) => {
        return (
          <Tbody key={index}>
            <DomainEventHeader
              domainEvent={domainEvent}
              expandedRows={expandedRows}
              handleExpanded={handleExpanded}
              index={index}
            />
            <DomainEventRow
              domainEvent={domainEvent}
              expandedRows={expandedRows}
              index={index}
            />
          </Tbody>
        )
      })}
    </TableComposable>
  )
}

export default styled(DomainEventsTable)``
